"use client";
import React, { useEffect, useState } from "react";
import ArticleCard from "./_UI/ArticleCard";
import { getAllBlogs } from "../../../lib/firebase/blogs";

const AllBlogs = () => {
  const [posts, setPosts] = useState([]);
  const [reload, setReload] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const p = await getAllBlogs();
        setPosts(p);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [reload]);
  return (
    <div className="max-w-7xl  py-10 bg-gray-900 my-10 px-5 rounded-xl">
      <h1 className="text-2xl font-bold">All Blogs</h1>
      <div className="mt-10 flex flex-col gap-y-4">
        {posts.map((post) => (
          <ArticleCard setReload={setReload} post={post} key={post.id} />
        ))}
      </div>
    </div>
  );
};

export default AllBlogs;
